import { render, staticRenderFns } from "./LoginChrismas.vue?vue&type=template&id=13fa6948&scoped=true"
import script from "./LoginChrismas.vue?vue&type=script&lang=js"
export * from "./LoginChrismas.vue?vue&type=script&lang=js"
import style0 from "./LoginChrismas.vue?vue&type=style&index=0&id=13fa6948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa6948",
  null
  
)

export default component.exports